import gql from 'not-graphql-tag';
import useAuthQuery from '../../../../hooks/useAuthQuery';
import {
  OutagesHistoryInput,
  OutagesHistoryResponse,
} from '../../../../__generated__/pge-types';

const OUTAGE_HISTORY_QUERY = gql`
  query getOutagesHistory($input: OutagesHistoryInput) {
    getOutagesHistory(input: $input) {
      outagesHistory {
        outageDate
        duration
        cause
        isPartialOutage
      }
      pdf
    }
  }
`;

export function useOutageHistory() {
  const {
    loading: outageHistoryLoading,
    error: outageHistoryError,
    data: outageHistoryData,
  } = useAuthQuery<
    { getOutagesHistory: OutagesHistoryResponse },
    OutagesHistoryInput
  >(OUTAGE_HISTORY_QUERY, {
    variables: {
      //TODO: update after final params are confirmed
      encryptedAccountNumber: '',
      encryptedPremiseId: '',
    },
  });

  return {
    isLoading: outageHistoryLoading,
    outageHistory: outageHistoryData?.getOutagesHistory?.outagesHistory,
    pdf: outageHistoryData?.getOutagesHistory?.pdf,
    isError: outageHistoryError,
  };
}
